import React from "react";

import {

  Card,
  CardContent,
  Typography,
 
} from "@mui/material";
import {

  Login,
  Delete,
  Edit,
  PersonAdd,
  
} from "@mui/icons-material";

import {
  Timeline,
  TimelineItem,
  TimelineSeparator,
  TimelineConnector,
  TimelineContent,
  TimelineDot,
} from "@mui/lab";


function SP_Activity() {

const activities = [
  { icon: <Login />, text: "Admin logged in", time: "2 mins ago", color: "primary" },
  { icon: <PersonAdd />, text: "New user created (Priya Sharma)", time: "15 mins ago", color: "success" },
  { icon: <Edit />, text: "Role updated for Ravi Kumar", time: "30 mins ago", color: "warning" },
  { icon: <Delete />, text: "User Kunal Mehta deleted", time: "1 hour ago", color: "error" },
];






  return (
    <div>
        
 
    <Card sx={{ mt: 3, borderRadius: 3, boxShadow: 3 }}>
      <CardContent>
        <Typography variant="subtitle1" gutterBottom>
          Recent Activity
        </Typography>
        <Timeline position="right" sx={{ p: 0 }}>
          {activities.map((act, i) => (
            <TimelineItem key={i}>
              <TimelineSeparator>
                <TimelineDot color={act.color}>{act.icon}</TimelineDot>
                {i < activities.length - 1 && <TimelineConnector />}
              </TimelineSeparator>
              <TimelineContent>
                <Typography variant="body2">{act.text}</Typography>
                <Typography variant="caption" color="text.secondary">
                  {act.time}
                </Typography>
              </TimelineContent>
            </TimelineItem>
          ))}
        </Timeline>
      </CardContent>
    </Card>
  

    </div>
  )
}

export default SP_Activity